import { useMutation } from '@tanstack/react-query';
import requestNumberPort from 'API/Numbers/requestNumberPort';
import { toast } from 'react-toastify';

const useRequestNumberPort = (data, currentCompany, currentScope) => {
    return useMutation({
        mutationFn: async () => {
            try {
                const res = await requestNumberPort({
                    currentCompany,
                    currentScope,
                    formData: data,
                });
                if (res.status === 200) {
                    toast.success('Number Port request success!');
                    return res;
                }
            } catch (error) {
                const errorMessage = `Failed to request Number Port: ${error?.response?.data?.message || 'There are some field errors'}`;
                toast.error(errorMessage);
                throw new Error(errorMessage);
            }
        },
    });
};

export default useRequestNumberPort;
